<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/jianjie' }">集团简介设置</el-breadcrumb-item>
			<el-breadcrumb-item>添加发展历程</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="110px" :model="formData">
				
				<el-form-item label="年份">
					<el-input v-model="formData.time"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="权重">
					<el-input v-model="formData.weights" type="number"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="内容">
					<!-- 富文本编辑器 -->
					<quill-editor v-model="formData.quillData" ref="myref"></quill-editor>
				</el-form-item>
			</el-form>

			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				formData: {
					time: '',
					weights: '',
					quillData:''

				},
				fileList: [],
				fileList2: [],
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo'
			}
		},
		created() {

		},
		methods: {
			onRemove(file, fileList) {//fileList剩下的会打印出来 response字段
				console.log('onRemove=' + JSON.stringify(fileList))
				var newfileList=[]
				this.fileList2.forEach((item1, index1) => {
					fileList.forEach((item2, index2) => {
						if (item1 == item2.response) {
							/* this.fileList2.splice(index1, 1) */
							newfileList.push(item2.response)
						}
					})
				})
				this.fileList2 = newfileList
				
			},
			onSuccess(res) {
				console.log('onSuccess=' + res)
				this.fileList2.push(res)
			},
			async submit() {
				var obj={};
				obj['developmentTime'] = this.formData.time;
				obj['weights'] = +this.formData.weights;
				obj['content'] = this.formData.quillData;
				console.log(JSON.stringify(obj))
				
				var res = await this.$http.post('/v1/official/manag/development/process/add',{
					request:obj
				})
				if(res.data.code == 0){
					 this.$message.success('添加成功');
					 this.$router.push({
						 path:'/jianjie'
					 })
				}else{
					this.$message.error(res.data.message)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.submitBtn {
		margin-left: 110px;
		margin-top: 90px;
	}
</style>
